import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getPage } from "../services/page";
import { useLocale } from "../stores/locale";

export function useGetPage(id?: string) {
  const { currentLanguage } = useLocale();

  return useQuery({
    queryKey: ["page", id, currentLanguage],
    queryFn: () => {
      if (!id) {
        throw new Error("Page ID is required");
      }
      return getPage(id, currentLanguage);
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
